import { render, staticRenderFns } from "./AssignTravelPolicyModal.vue?vue&type=template&id=b4cfa5d6&scoped=true&"
import script from "./AssignTravelPolicyModal.vue?vue&type=script&lang=js&"
export * from "./AssignTravelPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignTravelPolicyModal.vue?vue&type=style&index=0&id=b4cfa5d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cfa5d6",
  null
  
)

export default component.exports